import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { DialogData } from "src/app/helpers/interfaces";
import { DialogComponent } from "../dialog/dialog.component";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";
import { JsonPipe } from "@angular/common";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatDivider } from "@angular/material/divider";
@Component({
    selector: "cim-error-dialog",
    templateUrl: "./error-dialog.component.html",
    styleUrls: ["./error-dialog.component.scss"],
    standalone: true,
    imports: [
    MatDialogTitle,
    MatDivider,
    CdkScrollable,
    MatDialogContent,
    MatButton,
    MatIcon,
    MatDialogActions,
    MatDialogClose,
    JsonPipe
],
})
export class ErrorDialogComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}
  errorMsg;
  ngOnInit() {
    if (typeof this.data.error === "object") {
      this.errorMsg = undefined;
    } else {
      this.errorMsg = this.data.error;
    }
  }
  openLogs(noLanctBatch: string) {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: "100%",
      height: "95%",
      data: {modelName: 'JalonLogs',queryFilters: [{Name: 'NoLanctBatch',Value: noLanctBatch,QueryOperator: 'Equal'}], hideInputSearch: true},
    });

  }
}
